/* Notable box selector: choosing a tile swaps the large image. Click, tap, Enter/Space, and arrow keys all work. */
(function () {
  function init(root) {
    if (root.__nbxReady) return;
    root.__nbxReady = true;
    var tiles = Array.prototype.slice.call(root.querySelectorAll('[data-nbx-tile]'));
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-nbx-slide]'));
    var caption = root.querySelector('[data-nbx-caption]');
    if (!tiles.length || !slides.length) return;

    function select(tile, focus) {
      var id = tile.getAttribute('data-nbx-tile');
      tiles.forEach(function (t) {
        var on = t === tile;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      slides.forEach(function (s) {
        s.classList.toggle('is-active', s.getAttribute('data-nbx-slide') === id);
      });
      if (caption) caption.textContent = tile.getAttribute('data-nbx-caption-text') || '';
      if (focus) tile.focus();
    }

    tiles.forEach(function (tile, i) {
      tile.addEventListener('click', function () { select(tile, false); });
      tile.addEventListener('keydown', function (e) {
        var next = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = tiles[(i + 1) % tiles.length];
        if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = tiles[(i - 1 + tiles.length) % tiles.length];
        if (next) { e.preventDefault(); select(next, true); }
      });
    });

    /* make sure every box image is loaded once the page is idle, so switching never shows a blank frame */
    var warm = function () { root.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; }); };
    if ('requestIdleCallback' in window) requestIdleCallback(warm); else setTimeout(warm, 1500);
  }

  function boot() { document.querySelectorAll('[data-notable-nbx]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
